<template>
  <div class="layout-center-wrap">
    <section class="section-pt" aria-labelledby="intro-heading">
      <h2 id="intro-heading" class="section-title">공지사항 검색결과</h2>
      <div class="list-table__top">
        <p class="list-table__total">총 {{ noticePagingInfo.total }}건</p>
      </div>
      <!-- v-for 적용 테이블 -->
      <table class="list-table type-m-none-thead">
        <caption>
          공지사항 검색 목록
        </caption>
        <colgroup>
          <col width="80%" />
          <col width="10%" />
          <col width="10%" />
        </colgroup>
        <thead>
          <tr>
            <th scope="col">제목</th>
            <th scope="col">조회수</th>
            <th scope="col">작성일</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="item in noticeItems"
            :key="item.id"
            @click="goToDetail(item, 'noticeDetail')"
            class="clickable-row"
          >
            <td class="alignL">
              <span class="ellipsis">{{ item.title || "-" }}</span>
            </td>
            <td class="hit-field">{{ item.views || "-" }}</td>
            <td class="date-field">{{ convertDateFormat(item.regDate) }}</td>
          </tr>
        </tbody>
      </table>
      <div
        v-if="noticeItems == null || noticeItems.length == 0"
        class="no-data"
      >
        {{
          isLoading
            ? "데이터 조회중입니다. 잠시만 기다려주십시오."
            : "검색 결과 없음..."
        }}
      </div>

      <Paging
        v-model="noticePagingInfo.currentPage"
        :totalItems="noticePagingInfo.total"
        :visibleCount="noticePagingInfo.limitNum"
        @update:modelValue="getNoticePage"
      />
    </section>
    <section class="section-pt" aria-labelledby="intro-heading">
      <h2 id="intro-heading" class="section-title">보안공지 검색결과</h2>
      <div class="list-table__top">
        <p class="list-table__total">총 {{ vulNoticePagingInfo.total }}건</p>
      </div>
      <!-- v-for 적용 테이블 -->
      <table class="list-table type-m-none-thead">
        <caption>
          보안공지 목록
        </caption>
        <colgroup>
          <col width="80%" />
          <col width="10%" />
          <col width="10%" />
        </colgroup>
        <thead>
          <tr>
            <th scope="col">제목</th>
            <th scope="col">조회수</th>
            <th scope="col">작성일</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="item in vulnNoticeItems"
            :key="item.id"
            class="clickable-row"
            @click="goToDetail(item, 'vulnNoticeDetail')"
          >
            <td class="alignL">
              <span class="ellipsis">{{ item.title || "-" }}</span>
            </td>
            <td class="hit-field">{{ item.view_cnt || "-" }}</td>
            <td class="date-field">{{ convertDateFormatFromId(item.id) }}</td>
          </tr>
        </tbody>
      </table>
      <div
        v-if="vulnNoticeItems == null || vulnNoticeItems.length == 0"
        class="no-data"
      >
        {{
          isLoading
            ? "데이터 조회중입니다. 잠시만 기다려주십시오."
            : "검색 결과 없음..."
        }}
      </div>
      <Paging
        v-model="vulNoticePagingInfo.currentPage"
        :totalItems="vulNoticePagingInfo.total"
        :visibleCount="vulNoticePagingInfo.limitNum"
        @update:modelValue="getVulNoticePage"
      />
    </section>
    <section class="section-pt" aria-labelledby="intro-heading">
      <h2 id="intro-heading" class="section-title">공개된 취약점 검색결과</h2>
      <div class="list-table__top">
        <p class="list-table__total">총 {{ vulPublicPagingInfo.total }}건</p>
      </div>
      <!-- v-for 적용 테이블 -->
      <table class="list-table type-m-none-thead">
        <caption>
          공개된 취약점 검색결과
        </caption>
        <colgroup>
          <col width="80%" />
          <col width="10%" />
          <col width="10%" />
        </colgroup>
        <thead>
          <tr>
            <th scope="col">제목</th>
            <th scope="col">조회수</th>
            <th scope="col">작성일</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="item in vulnPublicItems"
            :key="item.id"
            class="clickable-row"
            @click="goToDetail(item, 'vulnPublicDetail')"
          >
            <td class="alignL">
              <span class="ellipsis">{{ item.title || "-" }}</span>
            </td>
            <td class="hit-field">{{ item.view_cnt || "-" }}</td>
            <td class="date-field">{{ convertDateFormatFromId(item.id) }}</td>
          </tr>
        </tbody>
      </table>
      <div
        v-if="vulnPublicItems == null || vulnPublicItems.length == 0"
        class="no-data"
      >
        {{
          isLoading
            ? "데이터 조회중입니다. 잠시만 기다려주십시오."
            : "검색 결과 없음..."
        }}
      </div>
      <Paging
        v-model="vulPublicPagingInfo.currentPage"
        :totalItems="vulPublicPagingInfo.total"
        :visibleCount="vulPublicPagingInfo.limitNum"
        @update:modelValue="getVulPublicPage"
      />
    </section>
  </div>
</template>
<script>
import dc from "@/component/DataChk.js";
import dt from "@/component/DateTime.js";
import paging from "@/component/Paging.js";
import tb from "@/component/Table.js";
import { onMounted, reactive, ref, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";

export default {
  setup() {
    const route = useRoute();
    const router = useRouter();
    const store = useStore();
    const showLoading = () => store.dispatch("loading/show");
    const hideLoading = () => store.dispatch("loading/hide");
    const isLoading = computed(() => store.state.loading.isLoading);

    // Helper to create all state for a list section
    const createListState = () => {
      const items = ref([]);
      const pagingInfo = reactive({
        currentPage: 1, // 현재페이지
        prePage: 1, // 이전페이지
        perPage: 10, // n개씩보기
        limitNum: 5, // 화면에 표시할 페이지 수
        type: 1, // 1 = 처음부터 조회, 2 = preKey/nextKey 사용, 3 = n개씩보기 변경
        total: -1,
        pageNum: 0,
        doubleTab: false,
      });
      return { items, pagingInfo };
    };

    //데이터 정의
    const { items: noticeItems, pagingInfo: noticePagingInfo } =
      createListState();
    const { items: vulnNoticeItems, pagingInfo: vulNoticePagingInfo } =
      createListState();
    const { items: vulnPublicItems, pagingInfo: vulPublicPagingInfo } =
      createListState();

    const searchInfo = ref({
      sortBy: "_id",
      order: -1,
      skipCount: 0,
      limit: 0,
      preKey: "",
      nextKey: "",
      changePerpage: false,
      collectionType: "",
    });
    const savedSearchInfo = ref({
      // getList(1) 후 저장된 검색 조건
      sortBy: "_id",
      order: -1,
      skipCount: 0,
      limit: 0,
      preKey: "",
      nextKey: "",
      changePerpage: false,
      collectionType: "",
    });
    const noticeUrl = "/core/pu/view/notice/get";
    const vulNoticeUrl = "/core/pu/view/vuln-notice/get";
    const vulPublicUrl = "/core/pu/view/vuln-public/get";
    const searchEndpoints = [
      {
        url: noticeUrl,
        ref: noticeItems,
        collectionType: "BOARDINFO",
        paging: noticePagingInfo,
      },
      {
        url: vulNoticeUrl,
        ref: vulnNoticeItems,
        collectionType: "VULNOTICE",
        paging: vulNoticePagingInfo,
      },
      {
        url: vulPublicUrl,
        ref: vulnPublicItems,
        collectionType: "DOMESTICVULINFO",
        paging: vulPublicPagingInfo,
      },
    ];
    //method정의
    const getNoticePage = (page) => {
      // 페이징 클릭 시 목록 조회
      noticePagingInfo.currentPage = page;
      noticePagingInfo.pageNum = page - noticePagingInfo.currentPage; // 클릭한 페이지 기준 차이
      noticePagingInfo.doubleTab = false;
      getList(noticeUrl, noticeItems, "BOARDINFO", noticePagingInfo, 2);
    };
    const getVulNoticePage = (page) => {
      // 페이징 클릭 시 목록 조회
      vulNoticePagingInfo.currentPage = page;
      vulNoticePagingInfo.pageNum = page - vulNoticePagingInfo.currentPage; // 클릭한 페이지 기준 차이
      vulNoticePagingInfo.doubleTab = false;

      getList(
        vulNoticeUrl,
        vulnNoticeItems,
        "VULNOTICE",
        vulNoticePagingInfo,
        2
      );
    };
    const getVulPublicPage = (page) => {
      // 페이징 클릭 시 목록 조회
      vulPublicPagingInfo.currentPage = page;
      vulPublicPagingInfo.pageNum = page - vulPublicPagingInfo.currentPage; // 클릭한 페이지 기준 차이
      vulPublicPagingInfo.doubleTab = false;
      getList(
        vulPublicUrl,
        vulnPublicItems,
        "DOMESTICVULINFO",
        vulPublicPagingInfo,
        2
      );
    };
    const getIntegratedSearch = async () => {
      showLoading();
      try {
        searchInfo.value = dc.trimObject(searchInfo.value);
        const promises = searchEndpoints.map((endpoint) =>
          getList(
            endpoint.url,
            endpoint.ref,
            endpoint.collectionType,
            endpoint.paging,
            1
          )
        );
        await Promise.allSettled(promises);
      } catch (error) {
        console.error(error);
      } finally {
        hideLoading();
      }
    };
    const getList = async (url, items, collectionType, pagingInfo, type) => {
      try {
        const searchPayload = { ...searchInfo.value };
        const axiosSearchInfo = tb.getSearchInfo(
          type,
          { value: searchPayload },
          savedSearchInfo
        );
        axiosSearchInfo.collectionType = collectionType;
        pagingInfo.type = type;
        const fetchPromises = [];
        if (type !== 2) {
          pagingInfo.total = -1;
          const countUrl = "/core/pu/view/count/get";
          const totalPromise = paging
            .total(countUrl, axiosSearchInfo)
            .then((res) => {
              pagingInfo.total = res;
            });
          fetchPromises.push(totalPromise);
        }

        const itemsPromise = paging
          .getPageItems(url, axiosSearchInfo, pagingInfo)
          .then((res) => {
            items.value = res || [];
            pagingInfo.doubleTab = true;
          });
        // 검색 조건 저장
        tb.saveSearchInfo(type, searchInfo, savedSearchInfo);
        fetchPromises.push(itemsPromise);
        await Promise.all(fetchPromises);
      } catch (error) {
        console.error(error);
        items.value = [];
        if (pagingInfo.total) {
          pagingInfo.total.value = 0;
        }
      }
    };
    const goToDetail = (item, name) => {
      // 상세 페이지로 이동
      router.push({
        name,
        query: {
          id: item.id,
        },
      });
    };

    const convertDateFormat = (date) => {
      return dt.dateFormat(date);
    };
    const convertDateFormatFromId = (objectId) => {
      return dt.dateFromObjectId(objectId);
    };
    // life cycle 정의
    onMounted(() => {
      const { content, searchOption, collectionType, tabs } = route.query;
      if (content) searchInfo.value.content = content;
      if (searchOption) searchInfo.value.searchOption = searchOption;
      if (collectionType) searchInfo.value.collectionType = collectionType;
      if (tabs) searchInfo.value.tabs = tabs;

      getIntegratedSearch();
    });
    // html에서 사용될 데이터 정의
    return {
      noticePagingInfo,
      vulNoticePagingInfo,
      vulPublicPagingInfo,
      getIntegratedSearch,
      getVulPublicPage,
      getNoticePage,
      getVulNoticePage,
      noticeItems,
      vulnNoticeItems,
      vulnPublicItems,
      convertDateFormat,
      goToDetail,
      convertDateFormatFromId,
      isLoading,
    };
  },
};
</script>
